import React from 'react';

const GiveUpButton = ({ handleGiveUp, t }) => {
  return (
    <button
      className="pretty-btn"
      style={{
        position: 'fixed',
        left: '50%',
        transform: 'translateX(-50%)',
        bottom: '70px',
        zIndex: 200,
        width: 'calc(100vw - 32px)',
        maxWidth: 400,
        background: '#fff',
        color: '#b85b7b',
        border: '1.5px solid #f8bfcf',
        fontWeight: 700,
        boxShadow: '0 2px 8px #f8bfcf40',
        padding: '1rem 0',
      }}
      onClick={handleGiveUp}
    >
      {t('give_up')}
    </button>
  );
};

export default GiveUpButton;
